import { render } from "./mypage.vue?vue&type=template&id=50550b10&ts=true"
import script from "./mypage.vue?vue&type=script&lang=ts&config=true"
export * from "./mypage.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__